import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { userActions, usersActions } from './users.actions';
import { UserDto, userInit } from './users.dtos';

const userReducer = combineReducers({
    list: createReducer<UserDto[]>([] as UserDto[])
      .handleAction(
        [
          usersActions.success,
        ], (state, action) => action.payload),
  
    user: createReducer<UserDto>(userInit)
      .handleAction(
        [
          userActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default userReducer;